export default __webpack_public_path__ + "static/media/bnr-mob.0e573339.png";